import React from 'react';
import './About.css';

const values = [
  { icon: '🤝', title: 'Trust', desc: 'Every professional is vetted, verified, and reviewed to ensure you always get reliable service.' },
  { icon: '⚡', title: 'Speed', desc: 'Book an appointment in under 60 seconds. We value your time as much as you do.' },
  { icon: '🌍', title: 'Accessibility', desc: 'Built for Africa and beyond — we make quality services accessible to everyone, everywhere.' },
  { icon: '💡', title: 'Innovation', desc: 'Constantly evolving with new features to make your experience simpler, better, and smarter.' },
];

const team = [
  { initials: 'JB', name: 'Joshua Bosoka', role: 'CEO & Co-founder', color: '#006666' },
  // { initials: 'KB', name: 'Kofi Boateng', role: 'CTO & Co-founder', color: '#008080' },
  // { initials: 'FN', name: 'Fatima Ndiaye', role: 'Head of Operations', color: '#004d4d' },
  // { initials: 'ES', name: 'Emmanuel Sarpong', role: 'Head of Growth', color: '#006666' },
];

export default function About() {
  return (
    <div className="page about-page">
      <section className="about-hero">
        <div className="container">
          <span className="section-label">Our Story</span>
          <h1 className="section-title">Built to Close the Skills Gap in Africa</h1>
          <p className="section-desc">
            AfreXpert was born from a simple frustration — finding a reliable handyman or professional should not be this hard. We built the solution.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mv-section">
        <div className="container mv-grid">
          <div className="mv-card mission">
            <div className="mv-icon">🎯</div>
            <h2>Our Mission</h2>
            <p>To empower skilled professionals across Africa by connecting them with clients who need their services — creating economic opportunity and reliable access to quality work.</p>
          </div>
          <div className="mv-card vision">
            <div className="mv-icon">🔭</div>
            <h2>Our Vision</h2>
            <p>A world where every skilled person has a fair chance to thrive, and every client can access expert help at their fingertips — regardless of location or background.</p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">What We Stand For</span>
            <h2 className="section-title">Our Core Values</h2>
          </div>
          <div className="values-grid">
            {values.map((v, i) => (
              <div key={i} className="value-card">
                <div className="value-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust */}
      <section className="trust-section">
        <div className="container trust-inner">
          <div className="trust-content">
            <span className="section-label">Why Trust Us</span>
            <h2 className="section-title">Your Safety is Our Priority</h2>
            <ul className="trust-list">
              <li><span className="check">✓</span> All professionals are identity-verified</li>
              <li><span className="check">✓</span> Genuine client reviews and ratings</li>
              <li><span className="check">✓</span> Secure in-app payments with dispute resolution</li>
              <li><span className="check">✓</span> 24/7 customer support team</li>
              <li><span className="check">✓</span> Background checks on licensed trades</li>
              <li><span className="check">✓</span> Data privacy compliant and encrypted</li>
            </ul>
          </div>
          <div className="trust-visual">
            <div className="trust-badge">
              <div className="badge-ring">
                <div className="badge-inner">
                  <span>🛡️</span>
                  <strong>Verified</strong>
                  <small>Platform</small>
                </div>
              </div>
              <div className="badge-stats">
                <div><strong>50K+</strong><span>Happy Clients</span></div>
                <div><strong>10K+</strong><span>Verified Pros</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">The Team</span>
            <h2 className="section-title">People Behind AfreXpert</h2>
          </div>
          <div className="team-grid">
            {team.map((m, i) => (
              <div key={i} className="team-card">
                <div className="team-avatar" style={{ background: m.color }}>{m.initials}</div>
                <h3>{m.name}</h3>
                <p>{m.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
